<template>
  <v-select class="w-full" 
    v-model="estado" 
    :options="estadosFiltrados" 
    label="estado"
    @input="changeValEstado"
    placeholder="Seleccione un estado"
    :disabled="disabled"
    :reduce="id => `/api/val_estados/${id.id}`" 
  />
</template>

<script>
import vSelect from 'vue-select'
import commonComponentsStore from '@/store/common-components/index.js'

export default {
  components: {
    'v-select': vSelect
  },
  props: {
    categoria: String,
    estadoSelected: [String, Object],
    disabled: Boolean
  },
  data () {
    return {
      estado: (this.estadoSelected !== null && this.estadoSelected !== undefined) ? JSON.parse(JSON.stringify(this.estadoSelected)) : null,
      estados: []
    }
  },
  computed: {
    estadosFiltrados () {
      const e = this.estados.filter(estado => estado.categoria === this.categoria)
      return e
    }
  },
  methods: {
    changeValEstado () {
      this.$emit('input', this.estado)
    }
  },
  async created () {
    if (!commonComponentsStore.isRegistered) {
      this.$store.registerModule('commonComponentsStore', commonComponentsStore)
      commonComponentsStore.isRegistered = true
    }
    this.estados = this.$store.state.commonComponentsStore.estados

  }
}
</script>

<style>

</style>